import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//models

//services

//component
import { AuthenticatedComponent} from "../../../../shared/components/AuthenticatedComponent";
import {CategoryService} from "../../../services/category.service";
import {BsModalRef} from "ngx-bootstrap";
@Component({
	selector: 'app-section-modal',
	templateUrl: './sortingCategories-modal.component.html',
	styleUrls: ['./sortingCategories-modal.component.scss']
})

export class SortingCategoriesModalComponent extends AuthenticatedComponent implements OnInit {

	constructor(public categoryService:CategoryService, public bsModalRef:BsModalRef){
		super();
	}
	sortList:Array<any>;
	clicked:boolean=false;
	ngOnInit() {
      this.categoryService.getSortmenu().subscribe(data=>
      {
            this.sortList= data.sort((a, b) => a.sortOrder - b.sortOrder);
      })
	}
  public save()
  {
    for (let i=0;i<this.sortList.length;i++)
    {
      this.sortList[i].sortOrder=i+1;
    }
    this.clicked=true;
    this.categoryService.UpdateSortmenu(this.sortList).subscribe(d => {
      this.clicked=false;
      if(!d.hasError) {
          this.alertService.showSuccess(this.translate.instant("alerts.SORTORDERUPDATEDSUCCESSFULLY"));
          this.bsModalRef.hide();
        }
       else {
        let errors = d.errors.map(r => {return r.message});
        this.alertService.showError(errors);
      }
    });
  }






}
